import React from 'react';
import { customer_id } from '../utils/DictionaryManagementUtils';
import DefaultPanelManuelRecipient from '../components/PanelsComponents/ManuelRecipient/DefaultPanelManuelRecipient';

//= ========================================================================
const Panel_B07_SendMoneyToCustomerIDManually = ({
  globJSON,
  selectedScreen,
  onConfigChanged,
  onGotoEdit,
  onStepPressed,
  language,
}) => (
  <DefaultPanelManuelRecipient
    globJSON={globJSON}
    selectedScreen={selectedScreen}
    onConfigChanged={onConfigChanged}
    onGotoEdit={onGotoEdit}
    onStepPressed={onStepPressed}
    language={language}
    manualName={customer_id}
    isHollow
  />
);

export default Panel_B07_SendMoneyToCustomerIDManually;
